<script setup>
import { useToasts } from './toast'

const items = useToasts()
</script>

<template>
  <div
    v-if="items.length"
    class="toasts"
    role="status"
    aria-live="polite"
  >
    <div
      v-for="toast in items"
      :key="toast.id"
      class="toast"
    >
      {{ toast.text }}
    </div>
  </div>
</template>
